/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash'
import moment from 'moment';

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetInProgressCustomerOrdersByCommandID(commandID) {
  const response = await $.soap({
    body: {
      GetInProgressCustomerOrdersByCommandID: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order',
        CommandID: commandID
      },
    },
    blueprintArrays : [
    'GetInProgressCustomerOrdersByCommandIDResponse.tuple'
    ],
    blueprint: {
      orders: ['$..GetInProgressCustomerOrdersByCommandIDResponse.tuple', {
        id: '$.old.CustomerOrder.ID',
        orderFormTypeID: '$.old.CustomerOrder.OrderFormTypeID',
        formCode: '$.old.CustomerOrder.FormCode',
        formName: '$.old.CustomerOrder.FormName',
        statusID: '$.old.CustomerOrder.StatusID',
        status: '$.old.CustomerOrder.ExternalOrderStatus',
        submittedOn: '$.old.CustomerOrder.SubmittedOn'
      }]
    }
  });
  
  cleanUpResponse(response);
  return response.orders;
}
